<template lang="pug">
y-dialog(v-if="showDialog" v-model="showDialog" persistent max-width=600 content-class="round-2xl")
  v-card
    v-card-title.px-4
      v-spacer
      .text-xl.font-bold {{ $t('confirm_connection') }}
      v-spacer
      v-btn(icon color="neutral700" @click="closeDialog")
        v-icon mdi-close
    v-divider
    div.py-6.px-10
      .text-md.font-normal {{ $t('confirm_connection_description', { connection: capitalizeWords(itemName), connectionType, company: capitalizeWords(company.name) }) }}&nbsp;
        span.clickable.underline.font-semibold(@click="$emit('back')") {{ $t('change_connection', { connectionType }) }}
      .my-4
        v-card.pa-4.round-lg.my-3(outlined)
          .text-md {{ itemName }}
          .text-sm.neutral500--text {{ itemId }}
    v-divider
    v-card-actions.px-6
      v-btn.button-md.neutral700--text.px-0.underline(text @click="$emit('back')") {{ $t('back') }}
      v-spacer
      v-btn.button-md(@click="nextAction" :loading="isLoading" color="neutral700" dark depressed) {{ $t('next') }}
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'ReviewConfirmSelectionDialog',
  props: {
    open: {
      type: Boolean,
    },
    selectedItem: {
      type: Object,
      required: true
    },
    connectionType: {
      type: String,
      required: true,
      validator(value) {
        return ['location', 'account'].includes(value)
      }
    }
  },
  data() {
    return {
      isLoading: false
    }
  },
  computed: {
    ...mapGetters({
      company: 'getCompany'
    }),
    showDialog: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    },
    itemId() {
      return this.connectionType === 'account' ? this.selectedItem.account_id : this.selectedItem.location_id
    },
    itemName() {
      return this.connectionType === 'account' ? this.selectedItem.account_name : this.selectedItem.location_name
    }
  },
  methods: {
    closeDialog() {
      this.$emit('cancel')
      this.showDialog = false
    },
    capitalizeWords(value) {
      return value.split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ')
    },
    nextAction() {
      this.isLoading = true
      this.$emit('next', this.selectedItem)
    }
  },
}
</script>